@switch (vm().kind) {
  @case ('centers') {
    @for (c of vm().centers; track $index) {
      <span class="hd-primary-conditioning__center"
            (mouseenter)="centerHover.emit(c.center)"
            (mouseleave)="centerHover.emit(null)">{{ c.name }}</span>@if (!$last) {<span>, </span>}
    }
  }
  @case ('bridgeGates') {
    @for (g of vm().gates; track $index) {
      <ng-container *ngTemplateOutlet="bridgeGate; context: { $implicit: g }" />@if (!$last) {<span>, </span>}
    }
  }
  @case ('bridgePairs') {
    @for (pair of vm().pairs; track $index) {
      <span class="hd-primary-conditioning__bridge-pair">@for (g of pair; track $index) {<ng-container *ngTemplateOutlet="bridgeGate; context: { $implicit: g }" />@if (!$last) {<span>-</span>}}</span>@if (!$last) {<span>, </span>}
    }
    <i class="fas fa-circle-info hd-primary-conditioning__info-icon"
       [title]="vm().longSplitInfo" aria-hidden="true"></i>
  }
  @case ('bridgeGeneric') {
    <span>{{ vm().genericText }}</span>
  }
}

<ng-template #bridgeGate let-g>
  @if (vm().style === 'badge') {
    <span class="hd-primary-conditioning__bridge-badge" [style.background-color]="g.color" [style.color]="g.textColor"
          (mouseenter)="bridgeGateHover.emit(g.gate)" (mouseleave)="bridgeGateHover.emit(null)"
          (click)="bridgeGateClicked.emit({ gate: g.gate, event: $event })">{{ g.gate }}</span>
  } @else {
    <span class="hd-primary-conditioning__bridge-dot-gate"
          (mouseenter)="bridgeGateHover.emit(g.gate)" (mouseleave)="bridgeGateHover.emit(null)"
          (click)="bridgeGateClicked.emit({ gate: g.gate, event: $event })"><span class="hd-primary-conditioning__bridge-dot" [style.background-color]="g.color"></span>{{ g.gate }}</span>
  }
</ng-template>
